import React, { useState } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

const AppQueryProvider = ({ children }: React.PropsWithChildren<unknown>) => {
    const [queryClientInstance] = useState<QueryClient>(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnWindowFocus: false,
                    },
                },
            })
    )

    return (
        <QueryClientProvider client={queryClientInstance}>
            {children}
            <ReactQueryDevtools />
        </QueryClientProvider>
    )
}

export default AppQueryProvider
